import { Drawer, List, ListItem, ListItemIcon, ListItemText, makeStyles, useMediaQuery } from '@material-ui/core'
import { mdiHome, mdiPhone } from '@mdi/js';
import Icon from '@mdi/react'
import React from 'react'
import { Link } from 'react-router-dom';

function Sidebar({ isDrawer, handleCloseDrawer }) {

    const mobile = useMediaQuery('(max-width: 400px)')
    const styles = useStyles({ mobile });


    return (
        <Drawer
            variant="persistent"
            anchor='top'
            open={isDrawer}
            classes={{
                paper: styles.paper
            }}
        >

            <Link to='/' className={styles.link}>
                <List component="nav" aria-label="main mailbox folders">
                    <ListItem button>
                        <ListItemIcon className={styles.listIcon} >
                            <Icon className={styles.itemIcon} path={mdiHome} size='1.4rem' />
                        </ListItemIcon>
                        <ListItemText primary="Home" />
                    </ListItem>
                </List>
            </Link>

            {/* <Link to="work" spy={true} smooth={true}>
                <List component="nav" aria-label="main mailbox folders">
                    <ListItem button>
                        <ListItemIcon className={styles.listIcon} >
                            <Icon className={styles.itemIcon} path={mdiAccountCog} size='1.4rem' />
                        </ListItemIcon>
                        <ListItemText primary="Skills" />
                    </ListItem>
                </List>
            </Link>

            <Link to="contact" spy={true} smooth={true}>
                <List component="nav" aria-label="main mailbox folders">
                    <ListItem button>
                        <ListItemIcon className={styles.listIcon} >
                            <Icon className={styles.itemIcon} path={mdiPhone} size='1.4rem' />
                        </ListItemIcon>
                        <ListItemText primary="Contact" />
                    </ListItem>
                </List>
            </Link> */}
        </Drawer>
    )
}

export default Sidebar

const useStyles = makeStyles(({
    drawer: {
        marginTop: '50px'
    },
    xIcon: {
        cursor: 'pointer',
        // zIndex: '-10',
        border: '2px solid black',
        borderRadius: '50%',
        '&:hover': {
            color: 'white',
            backgroundColor: '#E4FDE1',
            border: '2px solid #E4FDE1',
        }
    },
    closeIcon: {
        // position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        // alignItems: 'center',
        // marginLeft: '100px',
        textAlign: 'right',
    },
    paper: {
        top: '58px',
        height: '10%',
        backgroundColor: '#33658A',
        color: '#ffffff'
    },
    itemIcon: {
        color: '#ffffff'
    },
    link: {
        textDecoration: 'none',
        color: '#FFFFF2'
    }
}))
